import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { ShopState } from '../redux/shopSlice';

const useShopState = (): ShopState => {
  const shop = useSelector((state: RootState) => state.shop);
  return shop;
}

export default useShopState;
